import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1y3jfhqfro: FaireBrandEntity = {
  token: "b_1y3jfhqfro",
  type: "brand",
  name: "Hawkins New York",
  avatarUrl:
    "https://cdn.faire.com/fastly/2ddebf6849c5978162519de2cb1ddd556a27b338ddbe92d02b029f422bccb2cf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d9018b3b7abfca273ab748deddb2bcc67be113df8d54daad1efad17168679a2d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2ddebf6849c5978162519de2cb1ddd556a27b338ddbe92d02b029f422bccb2cf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d9018b3b7abfca273ab748deddb2bcc67be113df8d54daad1efad17168679a2d.jpeg",
  location: "Hudson, NY, USA",
  minimumOrderDollars: 1000,
  rating: 5,
  reviewCount: 10,
  isInsider: true,
  description:
    "Part design brand, part lifestyle collection.\nHawkins New York makes homewares that are intentional and unexpected. We spend our days thinking about the place where form and function overlap, and our nights figuring out how to turn our ideas into things you can hold, look at, and use.\n",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:18.758Z",
    importedBy: "entity-db-cli",
  },
};
